import {
  useCallback,
  useState,
} from "react";

import {
  fetchPortfolioDecision,
} from "../api/portfolioDecisionApi";


const getApiErrorMessage = (error) => {
  const responseData =
    error?.response?.data;

  if (
    typeof responseData?.detail ===
    "string"
  ) {
    return responseData.detail;
  }

  if (
    typeof error?.message ===
    "string"
  ) {
    return error.message;
  }

  return (
    "The portfolio decision could not " +
    "be completed."
  );
};


export const usePortfolioDecision = () => {
  const [
    portfolioDecision,
    setPortfolioDecision,
  ] = useState(null);

  const [
    loading,
    setLoading,
  ] = useState(false);

  const [
    error,
    setError,
  ] = useState(null);

  const runPortfolioDecision =
    useCallback(
      async (request) => {
        setLoading(true);
        setError(null);

        try {

          {/* 
          const result =
            await fetchPortfolioDecision(
              request
            );

          setPortfolioDecision(
            result
          );

          return result;
          */}
          
        const result =
          await fetchPortfolioDecision(
            request
          );

        console.log(
          "FULL PORTFOLIO DECISION >>>",
          result
        );

        console.log(
          "SELECTED ACTIONS >>>",
          result?.selected_actions
        );

        console.log(
          "FIRST ACTION >>>",
          result?.selected_actions?.[0]
        );

        setPortfolioDecision(
          result
        );

        return result;


        } catch (requestError) {
          const message =
            getApiErrorMessage(
              requestError
            );

          setError(message);
          setPortfolioDecision(null);

          throw requestError;
        } finally {
          setLoading(false);
        }
      },
      []
    );

  const clearPortfolioDecision =
    useCallback(() => {
      setPortfolioDecision(null);
      setError(null);
    }, []);

  return {
    portfolioDecision,
    loading,
    error,
    runPortfolioDecision,
    clearPortfolioDecision,
  };
};